import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxCheckbox, VtxIcon, VtxTooltip } from '@vertexinc/vtx-ui-react-component-library';
import TableManagementColumnProps from './TableManagementColumnProps.interface';
import './table-management.scss';

const TableManagementColumn = ({
  column,
  index,
  listId,
  isDragging,
  updateTableColumnVisibility,
}: TableManagementColumnProps): JSX.Element => {
  Logging.Debug('Table Column', column);

  let lockTooltip = 'The Position of this column is fixed and cannot be changed.';

  if (listId === 'droppableLeft') {
    lockTooltip += '\r\nNo column can be moved above this column.';
  } else if (listId === 'droppableRight') {
    lockTooltip += '\r\nNo column can be moved below this column.';
  }

  let pinningTooltip = 'The Pinning of this column is fixed and cannot be changed.';

  if (listId === 'droppableLeft') {
    pinningTooltip += '\r\nIt will always be Left pinned.';
  } else if (listId === 'droppableRight') {
    pinningTooltip += '\r\nIt will always be Right pinned.';
  }

  return (
    <div>
      <div className="tableManagementColumnContainer">
        <div className="tableManagementColumnVisibility">
          <VtxCheckbox
            id="visibleCheck"
            name="visibleCheck"
            className={isDragging ? 'tableManagementColumnDragging' : ''}
            checked={column.visibility}
            disabled={!column.canChangeVisibilty}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(event: any): void => updateTableColumnVisibility(listId, index, event.target.checked)}
          >
            {column.name}
          </VtxCheckbox>
          {
            !column.canMove && (
              <VtxTooltip title={lockTooltip}>
                <VtxIcon type="lock" fontSize={16} className="infoTooltip" />
              </VtxTooltip>
            )
          }
          {
            !column.canChangePin && (
              <VtxTooltip title={pinningTooltip}>
                <VtxIcon type="pushpin" fontSize={16} className="infoTooltip" />
              </VtxTooltip>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default TableManagementColumn;
